import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Mail, Phone, MapPin } from "lucide-react";
import { NEWS_URL } from "@/components/site/Navbar";
import { pushEvent } from "@/lib/gtm";

const LOGO = "https://media.base44.com/images/public/user_6962101245ec965f972f6d3a/eea077efa_LogoSeisfra.jpg";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white">
      <div className="h-1 bg-[#E4001C]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src={LOGO} alt="Seisfra logo" className="h-12 w-12 object-cover rounded-sm" />
            <span className="font-heading font-extrabold uppercase text-2xl">SEIS<span className="text-[#E4001C]">FRA</span></span>
          </div>
          <p className="text-[#A8ADB4] text-sm leading-relaxed max-w-md">Building and Bridge Expansion Joint System PH. Engineered movement joint systems for buildings, bridges, and infrastructure projects across the Philippines built for precision, durability, and long-term performance.



          </p>
          <a href="https://www.facebook.com/profile.php?id=61587997265633" target="_blank" rel="noopener noreferrer" aria-label="Seisfra on Facebook"
          onClick={() => pushEvent("social_media_click", { social_platform: "facebook", location: "footer" })}
          className="inline-flex mt-6 w-10 h-10 items-center justify-center border border-[#A8ADB4]/40 hover:border-[#E4001C] hover:text-[#E4001C] transition-colors">
            <Facebook className="w-5 h-5" />
          </a>
        </div>
        <div>
          <h4 className="font-tech font-semibold uppercase tracking-widest text-sm text-[#FF4D5E] mb-4">Quick Links</h4>
          <ul className="space-y-3">
            {[["Home", "/"], ["About", "/about"], ["Product", "/products"], ["Contact", "/contact"], ["FAQs", "/faqs"]].map(([label, to]) =>
            <li key={to}><Link to={to} className="font-tech text-[#A8ADB4] hover:text-white transition-colors uppercase tracking-wide text-sm">{label}</Link></li>
            )}
            <li><a href={NEWS_URL} target="_blank" rel="noopener noreferrer" className="font-tech text-[#A8ADB4] hover:text-white transition-colors uppercase tracking-wide text-sm">News</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-tech font-semibold uppercase tracking-widest text-sm text-[#FF4D5E] mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-[#A8ADB4]">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 shrink-0" /> 
32nd Street corner 11th Avenue Brgy. Fort Bonifacio, Bonifacio, Taguig, 1634 Metro Manila, Taguig, Philippines</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 shrink-0" /> <a href="tel:+639614407996" className="hover:text-white transition-colors">+63 961 4407 996</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 shrink-0" /> <a href="mailto:seisfraph@gmail.com" className="hover:text-white transition-colors">seisfraph@gmail.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center">
        <p className="font-tech text-xs uppercase tracking-widest text-[#A8ADB4]">
          © {new Date().getFullYear()} Seisfra — Building & Bridge Expansion Joint System PH. All rights reserved.
        </p>
      </div>
    </footer>);

}